import { Box, HStack, Text, VStack } from "@chakra-ui/react";
import { LuFolder, LuLayers } from "react-icons/lu";
import { removeFileExtension } from "../../../utilies/Utility";
import { useAppStore } from "../../../context/store";
import { useMapObjects } from "../../../context/MapObjectsContext";

function ActiveInfoBox() {
  const { mapObjects } = useMapObjects();
  const activeLayer = useAppStore((s) => s.activeLayer);
  const selectedProject = useAppStore((s) => s.selectedProject);
  const selectedTask = useAppStore((s) => s.selectedTask);

  const setIsOpenAddonsMenu = useAppStore((s) => s.setIsOpenAddonsMenu);
  const setIsAdminTaskListOpen = useAppStore((s) => s.setIsAdminTaskListOpen);
  const activeLayerObj = mapObjects?.find((obj) => obj.id === activeLayer);
  const activeLayerName = removeFileExtension(activeLayerObj?.file_name);

  const shouldShow = activeLayerObj?.file_name || selectedProject || selectedTask;

  if (!shouldShow) return null;

  return (
    <Box bg={"white"} borderRadius={"md"} p={2} px={3}>
      <VStack gap={0}>
        {selectedProject?.project_name && (
          <HStack width={"full"}>
            <LuFolder />
            <Text
              cursor={"pointer"}
              fontSize={"13px"}
              onClick={() => {
                setIsOpenAddonsMenu(true);
                setIsAdminTaskListOpen(false);
              }}
            >
              Active Project:
            </Text>
            <Text
              fontWeight={"bold"}
              fontSize={"15px"}
              cursor={"pointer"}
              onClick={() => {
                setIsOpenAddonsMenu(true);
                setIsAdminTaskListOpen(false);
              }}
            >
              {selectedProject.project_name}
            </Text>
          </HStack>
        )}

        {activeLayerName && (
          <HStack width={"full"}>
            <LuLayers />
            <Text
              cursor={"pointer"}
              fontSize={"13px"}
              onClick={() => {
                setIsOpenAddonsMenu(true);
                setIsAdminTaskListOpen(false);
              }}
            >
              Active Layer:
            </Text>
            <Text
              cursor={"pointer"}
              fontWeight={"bold"}
              fontSize={"15px"}
              onClick={() => {
                setIsOpenAddonsMenu(true);
                setIsAdminTaskListOpen(false);
              }}
            >
              {activeLayerName}
            </Text>
          </HStack>
        )}

        {selectedTask && (
          <HStack width={"full"}>
            <LuLayers />
            <Text
              fontSize={"13px"}
              cursor={"pointer"}
              onClick={() => {
                setIsOpenAddonsMenu(false);
                setIsAdminTaskListOpen(true);
              }}
            >
              Active Task:
            </Text>
            <Text
              fontWeight={"bold"}
              fontSize={"15px"}
              cursor={"pointer"}
              onClick={() => {
                setIsOpenAddonsMenu(false);
                setIsAdminTaskListOpen(true);
              }}
            >
              {selectedTask.title}
            </Text>
          </HStack>
        )}
      </VStack>
    </Box>
  );
}

export default ActiveInfoBox;
